import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import {
  completeSubtaskResourcePath,
  completeSubtaskResourceType,
} from "../resources/subtask/subtaskResourceConsts";

export type CompleteSubtaskMutationPayload = {
  comment: string;
  userGroupId: string;
  subtaskId: string;
};

export function completeSubtaskMutation(jsonApi: JsonApiClient) {
  return ({
    comment,
    userGroupId,
    subtaskId,
  }: CompleteSubtaskMutationPayload) =>
    jsonApi.createOne({
      path: completeSubtaskResourcePath(userGroupId, subtaskId),
      type: completeSubtaskResourceType,
      attributes: {
        comment,
      },
    });
}
